import { Trans } from '@lingui/react'
import { isNil } from 'ramda'

import { Typography } from '@twisto/components/atoms/typography'
import {
  InstallmentsExistingIcon,
  InstallmentsNewIcon,
  TwistoOutlineIcon,
} from '@twisto/icons'

import { InstallmentMinDueAmountTableRow } from './installments-min-due-amount-table-row'
import * as styles from './installments-min-due-amount-table.styles'

type Props = {
  periodsMinPortion: string | null
}

export const InstallmentsMinDueAmountTable = ({ periodsMinPortion }: Props) => (
  <div css={styles.root} data-testid="minimum-due-amount-table">
    <Typography color="textPrimary" fontWeight="medium" variant="b2">
      <Trans id="flow.components.minimumDueAmount.table.title" />
    </Typography>
    <InstallmentMinDueAmountTableRow icon={InstallmentsNewIcon}>
      <Trans id="flow.components.minimumDueAmount.table.installmentsNew" />
    </InstallmentMinDueAmountTableRow>
    <InstallmentMinDueAmountTableRow icon={InstallmentsExistingIcon}>
      <Trans id="flow.components.minimumDueAmount.table.installmentsExisting" />
    </InstallmentMinDueAmountTableRow>
    {!isNil(periodsMinPortion) && (
      <InstallmentMinDueAmountTableRow icon={TwistoOutlineIcon}>
        <Trans
          id="flow.components.minimumDueAmount.table.minimumFromPurchases"
          values={{ percentage: periodsMinPortion }}
        />
      </InstallmentMinDueAmountTableRow>
    )}
  </div>
)
